import { MessageDialog } from '../../../framework/frontend/MessageDialog';
import { AbstractBlock } from '../AbstractBlock';
import { blocklyDispatcher } from '../blocklyDispatcher';
import { blocklyStore } from '../blocklyStore';
import { block_translation } from '../../lang/BlockTranslation';
import { translation } from '../../lang/Translation';
const bt = block_translation;
const t = translation;
export class FileUploaderButton extends AbstractBlock {
  constructor() {
    super(
      'file-uploader',
      t.to('3Dモデル、画像、動画、音楽のファイル(マイアセット)', 'file_manager')
    );
    // ワークスペースをマウントしたときにイベントをハンドリング
    blocklyDispatcher.addMountedWorkspaceListener(function (workspace) {
      workspace.registerButtonCallback('click_file_uploader_button', () => {
        blocklyStore
          .save()
          .then((value) => {
            MessageDialog.info(value);
            const project_id = blocklyStore.project_id;
            location.href = `/files/${project_id}?page=user`;
          })
          .catch((error) => MessageDialog.systemError(error, bt.to('保存', 'save')));
      });
      blocklyDispatcher.triggerUpdateToolbox(workspace);
    });
  }

  toXml(): HTMLElement {
    const el = document.createElement('button');
    el.setAttribute('text', this.title);
    el.setAttribute('callbackKey', 'click_file_uploader_button');
    el.setAttribute('web-class', 'file_up_button');
    return el;
  }
}
